import { useUser } from 'app/user/application'

import styles from './ErrorPage.module.scss'

const ErrorPage = ({
  error,
}: {
  error: Error
  resetErrorBoundary: (...args: unknown[]) => void
}) => {
  const { logout } = useUser()

  return (
    <div className={styles.error}>
      <h3>Something went wrong</h3>
      <pre>{error.message}</pre>
      <a href="/">Back to home</a>
      <br />

      <a onClick={() => void logout()}>Logout</a>
    </div>
  )
}

export default ErrorPage
